<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue" @click="$router.push({ path: '/user/data' })"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.phone || userInfo.nickname }}</div>
          </div>
          <div class="auth-status" @click="$router.push({ path: '/user/binding' })">
            <div v-if="userInfo.auth_status==0">
              <van-tag class="tag" type="warning">
                未实名认证
              </van-tag>
            </div>
            <div v-else-if="userInfo.auth_status==1">
              <van-tag class="tag" type="primary">
                认证待审核
              </van-tag>
            </div>
            <div v-else-if='userInfo.auth_status==2'>
              <van-tag class="tag" type="success">
                已实名认证
              </van-tag>
            </div>
            <div v-else-if='userInfo.auth_status==3'>
              <van-tag class="tag" type="warning">
                认证未审核通过
              </van-tag>
            </div>
          </div>
          <!-- <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.uid || 0 }}<span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link> -->
        </div>
      </div>
      <span class="iconfont icon-shezhi" @click="$router.push({ path: '/user/data' })"></span>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <!-- <router-link :to="{ path: '/user/account' }" class="item" v-if="showBtnText == ''">
          <div>我的额度</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <router-link :to="{ path: '/user/binding' }" class="item" v-else>
          <div>我的额度</div>
          <div class="btnText">{{ showBtnText }}</div>
        </router-link> -->
        <!--<router-link-->
        <!--:to="'/user/user_promotion'"-->
        <!--class="item"-->
        <!--v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"-->
        <!--&gt;-->
        <!-- <div @click="goPagey('/user/user_promotion')" class="item"
          v-if="userInfo.is_promoter === 1 || userInfo.statu === 2">
          <div>当前佣金</div>
          <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
        </div> -->

        <!--</router-link>-->
        <!-- <router-link :to="'/user/integral'" class="item" v-else>
          <div>当前积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link> -->

        <router-link v-if="(parseFloat(userInfo.now_money) || 0) === 0" :to="{ path: '/deposit/57' }" class="item">
          <div>押金余额</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <router-link v-else :to="{ path: '/order/list/' + 4 }" class="item">
          <div>押金余额</div>
          <div class="num">{{ userInfo.now_money }}</div>
        </router-link>

        <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>
        
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span class="order-status-num" v-if="orderStatusNum.unpaid_count > 0">{{ orderStatusNum.unpaid_count
                }}</span>
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span class="order-status-num" v-if="orderStatusNum.unshipped_count > 0">{{ orderStatusNum.unshipped_count
                }}</span>
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span class="order-status-num" v-if="orderStatusNum.received_count > 0">{{ orderStatusNum.received_count
                }}</span>
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span class="order-status-num" v-if="orderStatusNum.evaluated_count > 0">{{ orderStatusNum.evaluated_count
                }}</span>
            </div>
            <div>分期中</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span class="order-status-num" v-if="orderStatusNum.refund_count > 0">{{ orderStatusNum.refund_count
                }}</span>
            </div>
            <div>售后/退款</div>
          </router-link>
        </div>
      </div>
      <div class="myService">
        <!-- <div class="title acea-row row-middle">我的服务</div> -->
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div v-if="index > 0" class="line"></div>
            <div class="item acea-row row-between-wrapper" :key="index" @click="goPages(index)" v-if="item.wap_url">
              <div class="acea-row row-middle">
                <div class="pictrue"><img :src="item.pic" /></div>
                <div class="service-name">{{ item.name }}</div>
              </div>
              <span class="iconfont icon-jiantou"></span>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
      <div v-if="showBindBtn" class="bindPhoneAccount bg-color-red" @click="bindPhoneAccount">绑定已有手机账号</div>
      <div style="height: 1.8rem; width: 100%;"></div>
    </div>
    <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type">
    </SwitchWindow>
    <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent">
    </GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
import { Tag } from "vant";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow,
    vanTag: Tag // 注册组件别名（或直接用Tag）
  },
  props: {},
  data: function () {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      showBtnText: '',
      showBindBtn: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function () {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function (data) {
      this.switchActive = data;
    },
    User: function () {
      let that = this;
      getUser().then(res => {
        if (res.data.auth_status == 0) {
          that.showBtnText = '申请评估';
        } else if (res.data.auth_status == 1) {
          that.showBtnText = '评估中';
        } else {
          that.showBtnText = '';
        }
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        that.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };
        that.$store.commit("UPDATE_USERINFO", res.data);

        if(that.isWeixin && that.userInfo.user_type == 'wechat' && that.userInfo.auth_status == 0) {
          that.showBindBtn = true;
          let showBindDialogCount = that.$store.state.app.showBindDialogCount - 1;
          if(showBindDialogCount < 0) {
            that.$store.commit("SHOW_BIND_DIALOG", 5);
            that.$dialog.confirm({
              title: '当前是微信快捷登录',
              mes: '您可以绑定已有手机账号！',
              opts: [
                {
                  txt: "取消",
                  color: false,
                  callback: () => {  
                  }
                },
                {
                  txt: "去绑定",
                  color: false,
                  callback: () => {
                    that.bindPhoneAccount();
                  }
                }
              ]
            });
          } 
          else {
            that.$store.commit("SHOW_BIND_DIALOG", showBindDialogCount);
          }
        } 
        else {
          that.showBindBtn = false;
        }
      });
    },
    MenuUser: function () {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    bindPhoneAccount: function () {
      this.$router.push({ path: '/user/bind_phone_account' });
    },
    goPages: function (index) {
      let url = this.MyMenus[index].wap_url;
      if (url.indexOf('makePhoneCall-') === 0) {
        let phone = url.substring('makePhoneCall-'.length);
        return this.$dialog.alert({ mes: '如您需要帮助，请添加客服企业微信或拨打客服电话：' + phone }, () => { });
      }
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}

.user .auth-status {
  margin-top: 0;
  width: 60%;
  text-align: left;
  background-color: transparent;
  padding: 0.02rem 0 0.1rem 0.05rem;
}

.user .order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.user .pictrue {
  position: relative;
}

.user .switch-h5 {
  margin-left: 0.2rem;
}

.user .binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}

.bindPhoneAccount {
  font-size: 0.32rem;
  width: 5.8rem;
  height: 0.9rem;
  border-radius: 0.45rem;
  color: #fff;
  margin: 0.6rem auto 0.3rem auto;
  text-align: center;
  line-height: 0.9rem;
}
</style>
